import { render, staticRenderFns } from "./VenueSwitcherPage.vue?vue&type=template&id=38815c12&scoped=true"
import script from "./VenueSwitcherPage.vue?vue&type=script&lang=js"
export * from "./VenueSwitcherPage.vue?vue&type=script&lang=js"
import style0 from "./VenueSwitcherPage.vue?vue&type=style&index=0&id=38815c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38815c12",
  null
  
)

export default component.exports